import Vue from 'vue';
import Router from 'vue-router';
import { role } from './services/constants';
import store from './store';

// import store from '@/store/index';
import * as userService from '@/services/user.service';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('./layout/MenuLayout.vue'),
      // meta: { requiresAuth: true },
      children: [
        {
          // -------C018 TOP PAGE PRODUCT LIST-----------
          path: '/',
          name: 'TopPage',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/products/list/list.vue')
        },
        {
          // -------C018 TOP PAGE PRODUCT LIST-----------
          path: 'customer/search/:category_id?',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/products/top-page/top-page.vue')
        },
        {
          // -------Q&A TOP-----------
          path: 'question-answer',
          name: 'QATop',
          meta: {
            // Not need for login when access Q&A
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/list/top.vue')
        },
        {
          // -------Q&A CATEGORY LIST-----------
          path: 'question-answer/category/:id',
          name: 'QACategory',
          meta: {
            // Not need for login when access Q&A
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/list/category.vue')
        },
        {
          // -------Q&A SEARCH LIST-----------
          path: 'question-answer/search',
          name: 'QASearch',
          meta: {
            // Not need for login when access Q&A
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/list/search.vue')
        },
        {
          // -------Q&A SEARCH LIST-----------
          path: 'question-answer/my-questions',
          name: 'QAMyQuestions',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/list/my-questions.vue')
        },
        {
          // -------Q&A DETAIL-----------
          path: 'question-answer/detail/:id',
          name: 'QuestionDetail',
          meta: {
            // Not need for login when access Q&A
            customerGuard: false,
            privateKeyGuard: true,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/detail/detail.vue')
        },
        {
          // -------Q&A DETAIL-----------
          path: 'question-answer/detail/:id/add',
          name: 'AnswerAdd',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/detail/answer-edit.vue'),
          props: true
        },
        {
          // -------Q&A DETAIL-----------
          path: 'question-answer/detail/:id/edit/:answerId',
          name: 'AnswerEdit',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: []
          },
          component: () => import('./views/customer/question-answer/detail/answer-edit.vue')
        },
        {
          // -------Q&A LIST-----------
          path: 'question-answer/add',
          name: 'QuestionAdd',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'ユーザーQ&A', link: '/question-answer' },
              { name: '質問を投稿' }
            ]
          },
          component: () => import('./views/customer/question-answer/add-edit/add-edit')
        },
        {
          // -------Q&A LIST-----------
          path: 'question-answer/:id/edit',
          name: 'QuestionEdit',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'ユーザーQ&A', link: '/question-answer' },
              { name: '質問を編集' }
            ]
          },
          component: () => import('./views/customer/question-answer/add-edit/add-edit')
        },
        {
          path: '/loom',
          component: () => import('./views/LoomContractSample.vue')
        },
        {
          // -------C021 PRODUCT DETAIL-----------
          path: 'customer/product/detail/:id',
          name: 'CustomerProductDetail',
          meta: {
            customerGuard: false,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: []
          },
          component: () => import('./views/customer/products/detail/detail.vue')
        },
        {
          path: 'customer/my-page',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: [{ name: 'ホーム', link: '/' }, { name: 'マイページ' }, { name: '会員情報' }]
          },
          component: () => import('./views/customer/my-page/my-page/my-page.vue')
        },
        {
          path: 'customer/my-page/recommend',
          name: 'RecommendList',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: 'おすすめリスト' }
            ]
          },
          component: () => import('./views/customer/my-page/recommend/recommend.vue')
        },
        {
          path: 'customer/my-page/recommend/guide',
          name: 'RecommendGuide',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: [{ name: 'ホーム', link: '/' }, { name: 'おすすめとは？' }]
          },
          component: () => import('./views/customer/my-page/recommend/guide/guide.vue')
        },
        {
          path: 'customer/my-page/password-reset',
          meta: {
            customerGuard: false,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '会員情報' }
            ]
          },
          component: () => import('./views/customer/my-page/password-reset/password-reset')
        },
        {
          path: 'customer/my-page/mail-reset',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '会員情報' }
            ]
          },
          component: () => import('./views/customer/my-page/mail-reset/mail-reset')
        },
        {
          path: 'customer/my-page/rename',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '会員情報' }
            ]
          },
          component: () => import('./views/customer/my-page/rename/rename')
        },
        {
          path: 'customer/my-page/address/add',
          name: 'CustomerAddAddress',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '会員情報' }
            ]
          },
          component: () => import('./views/customer/my-page/address/add-edit-address')
        },
        {
          path: 'customer/my-page/address/edit/:id',
          name: 'CustomerEditAddress',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '会員情報' }
            ]
          },
          component: () => import('./views/customer/my-page/address/add-edit-address')
        },
        {
          // -------C010 MY PAGE-----------
          path: 'customer/my-page/profile',
          name: 'CustomerProfile',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '会員情報' }
            ]
          },
          component: () => import('./views/customer/my-page/profile/profile.vue')
        },
        {
          // -------C010 MY PAGE FAVOURITE-----------
          path: 'customer/my-page/favourite',
          name: 'CustomerFavorite',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: 'マイリスト' }
            ]
          },
          component: () => import('./views/customer/my-page/prod-favourite/prod-favourite.vue')
        },
        {
          // -------C019 CUSTOMER DETAIL-----------
          path: 'customer/my-page/detail',
          name: 'CustomerDetail',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/my-page/customer-detail/customer-detail.vue')
        },
        {
          // -------C020 SHOP DETAIL-----------
          path: 'customer/shop/:shop_id',
          name: 'CustomerShopDetail',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/shop/detail/detail.vue')
        },
        {
          // -------C030 REVIEWS LIST SHOP-----------
          path: 'shop/:shopId/reviews',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: [{ name: 'ホーム', link: '/' }, { name: 'ショップレビュー' }]
          },
          component: () => import('./views/shop/reviews/list/list')
        },
        {
          // -------C031 REVIEWS DETAIL SHOP-----------
          path: 'customer/review-detail/:reviewId',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: [{ name: 'ホーム', link: '/' }, { name: '家電' }]
          },
          component: () => import('./views/shop/reviews/detail/detail')
        },
        {
          // -------C022 CART DETAIL-----------
          path: 'customer/cart/detail',
          name: 'CustomerCartDetail',
          meta: { customerGuard: false, shopGuard: false, breadcrumbs: [] },
          component: () => import('./views/customer/order/cart/cart-detail/cart-detail.vue')
        },
        {
          // -------C019 CUSTOMER DETAIL REVIEW LIST-----------
          path: 'customer/reviews/list/:customer_id',
          name: 'CustomerReviewList',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/reviews/list/list.vue')
        },
        {
          // -------C027 ORDER LIST-----------
          path: 'customer/order/list',
          name: 'CustomerOrderList',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '注文履歴' }
            ]
          },
          component: () => import('./views/customer/order/order-list/order-list.vue')
        },
        {
          // -------C028 ORDER DETAIL -----------
          path: 'customer/order/detail/:orderId',
          name: 'CustomerOrderDetail',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'マイページ', link: '/customer/my-page' },
              { name: '注文履歴', link: '/customer/order/list' },
              { name: '注文詳細' }
            ]
          },
          component: () => import('./views/customer/order/order-detail/order-detail.vue')
        },
        {
          // -------C032 CUSTOMER REVIEW DETAIL -----------
          // -------C033 CUSTOMER REVIEW DETAIL CONFIRM -----------
          // -------C034 CUSTOMER REVIEW COMPLETED -----------
          path: 'customer/review-shop/:shopId/:orderId',
          name: 'ReviewForShop',
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: [{ name: 'ホーム', link: '/' }, { name: 'ショップレビュー入力', link: '' }]
          },
          component: () => import('./views/customer/reviews/form/form'),
          props: true
        },
        {
          path: 'customer/review-product/:productId/:orderId',
          name: 'ReviewForProduct',
          meta: {
            customerGuard: true,
            privateKeyGuard: true,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/reviews/product/form/form'),
          props: true
        },
        {
          path: 'customer/product/:productId/reviews',
          name: 'ProductReviewList',
          meta: {
            customerGuard: false,
            shopGuard: false,
            breadcrumbs: []
          },
          component: () => import('./views/customer/reviews/product/list/page.vue')
        },
        {
          // -------C035 NOTIFICATION LIST -----------
          path: 'customer/notification/list',
          name: 'CustomerNotificationList',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: [{ name: 'ホーム', link: '/' }, { name: 'お知らせ一覧' }]
          },
          component: () => import('./views/customer/notifications/list/list')
        },
        {
          // -------C036 NOTIFICATION DETAIL -----------
          path: 'customer/notification/:itemId',
          meta: {
            customerGuard: true,
            shopGuard: false,
            breadcrumbs: [
              { name: 'ホーム', link: '/' },
              { name: 'お知らせ一覧', link: '/customer/notification/list' },
              { name: 'お知らせ詳細' }
            ]
          },
          component: () => import('./views/customer/notifications/detail/detail')
        }
      ]
    },
    {
      path: '/shop',
      component: () => import('./layout/ShopLayout.vue'),
      children: [
        {
          // -------S001 Shop MANAGE Page -----------
          path: '',
          name: 'ShopManage',
          meta: { customerGuard: true, shopGuard: true },
          component: () => import('./views/shop/manage/manage-page.vue')
        },
        {
          // -------S002 MANAGE PRODUCT LIST -----------
          path: 'list',
          name: 'ShopProductList',
          meta: { customerGuard: true, shopGuard: true, privateKeyGuard: true },
          component: () => import('./views/shop/products/list/list.vue'),
          props: true
        },
        {
          // -------S003 MANAGE PRODUCT REGISTER -----------
          path: 'product/add',
          name: 'ShopProductAdd',
          meta: { customerGuard: true, shopGuard: true, privateKeyGuard: true },
          component: () => import('./views/shop/products/add-edit/add-edit.vue')
        },
        {
          // -------S003 MANAGE PRODUCT EDIT -----------
          path: 'product/:id/edit',
          name: 'ShopProductEdit',
          meta: { customerGuard: true, shopGuard: true, privateKeyGuard: true, messageProp: true },
          component: () => import('./views/shop/products/add-edit/add-edit.vue')
        },
        {
          // -------S007 ORDER LIST -----------
          path: 'order/list',
          name: 'ShopOrderList',
          meta: { customerGuard: true, shopGuard: true, privateKeyGuard: true },
          component: () => import('./views/shop/order/list/list.vue'),
          props: true
        },
        {
          // -------S008 ORDER DETAIL -----------
          path: 'order/detail/:orderId',
          name: 'ShopOrderDetail',
          meta: { customerGuard: true, shopGuard: true, privateKeyGuard: true },
          component: () => import('./views/shop/order/detail/detail.vue')
        },
        {
          //--------S014---------

          path: 'sale-statistics',
          name: 'ShopSaleStatistics',
          meta: { customerGuard: true, shopGuard: true },
          component: () => import('./views/shop/statistics/sale.vue')
        },
        //--------S015---------
        {
          path: 'setting',
          name: 'ShopSetting',
          meta: { customerGuard: true, shopGuard: true, privateKeyGuard: true },
          component: () => import('./views/shop/setting/setting.vue')
        }
      ]
    },
    {
      path: '/shop',
      component: () => import('./layout/ShopLayout.vue'),
      children: [
        {
          // -------S011 CUSTOMER REVIEW INPUT -----------
          // -------S012 CUSTOMER REVIEW CONFIRM -----------
          // -------S013 CUSTOMER REVIEW COMPLETED -----------
          path: 'review-customer/:customerId/:orderId',
          name: 'CustomerReviewAdd',
          meta: {
            customerGuard: true,
            shopGuard: true,
            breadcrumbs: []
          },
          component: () => import('./views/shop/reviews/form/form'),
          props: true
        }
      ]
    },
    {
      path: '/',
      component: () => import('./layout/LogoLayout.vue'),
      children: [{ path: '/oauth', component: () => import('./views/OAuthSample.vue') }]
    },
    {
      path: '/',
      component: () => import('./layout/LogoLayout.vue'),
      children: [
        // ------CUSTOMER-------------------
        {
          path: 'customer/login',
          props: true,
          name: 'login',
          meta: { customerGuard: false, shopGuard: false, indexOfPath: true },
          component: () => import('./views/customer/login/login.vue')
        },
        {
          path: 'customer/register',
          meta: { customerGuard: false, indexOfPath: true },
          component: () => import('./views/customer/register/register/register.vue')
        },
        {
          path: 'customer/register-confirm',
          meta: { customerGuard: false, indexOfPath: true },
          component: () => import('./views/customer/register/register-confirm/register-confirm.vue'),
          props: true
        },
        {
          path: 'customer/register-complete',
          meta: { customerGuard: false, indexOfPath: true },
          component: () => import('./views/customer/register/register-complete/register-complete.vue'),
          props: true
        },
        {
          // -------C023 DELEVERY ADDRESS REGISTRATION -----------
          path: 'customer/order/order-settlement',
          name: 'AddressRegistration',
          props: true,
          meta: {
            customerGuard: true,
            shopGuard: false,
            privateKeyGuard: true,
            breadcrumbs: []
          },
          component: () => import('./views/customer/order/order-settlement/order-settlement.vue')
        },
        // ------OWNER-------------------
        {
          path: 'shop/login',
          meta: { customerGuard: true, shopGuard: false },
          component: () => import('./views/customer/login/login.vue')
        },
        {
          path: 'shop/register',
          name: 'ShopRegister',
          meta: { customerGuard: true, privateKeyGuard: true },
          component: () => import('./views/shop/register/register.vue')
        },
        {
          path: 'shop/register-confirm',
          name: 'ShopRegisterConfirm',
          meta: { customerGuard: true },
          component: () => import('./views/shop/register/confirm.vue'),
          props: true
        },
        {
          path: 'shop/register-complete',
          name: 'ShopRegisterComplete',
          meta: { customerGuard: true },
          component: () => import('./views/shop/register/complete.vue'),
          props: true
        }
      ]
    },
    {
      path: '/language',
      component: () => import('./views/Language.vue')
    },
    {
      path: '/email-action-handle',
      component: () => import('./views/email-action/handle.vue')
    },
    {
      path: '*',
      component: () => import('./views/errors/Error404.vue')
    }
  ]
});
router.beforeEach((to, from, next) => {
  const messageProp = to.matched.some(record => record.meta.messageProp);
  if (!messageProp) {
    store.commit('messageId/updateMessageIdErrorState', null);
    store.commit('messageId/updateMessageIdSuccesState', null);
  }
  const privateKeyGuard = to.matched.some(record => record.meta.privateKeyGuard);

  let r = '';
  const customerGuard = to.matched.some(record => record.meta.customerGuard);
  const shopGuard = to.matched.some(record => record.meta.shopGuard);
  const indexOfPath = to.matched.some(record => record.meta.indexOfPath);
  userService
    .getCurrentUser()
    .then(user => {
      if (privateKeyGuard) {
        const decryptKey = userService.getDecryptKey();
        if (!decryptKey) {
          return userService.logout().then(() => {
            return next({
              name: 'login',
              params: {
                page_expectations: to.fullPath
              }
            });
          });
        }
      }
      //if user exits
      // eslint-disable-next-line
      userService.getUserRole(user.uid).then(result => {
        //if customer guard required login and role is null then render login
        if (customerGuard && !result.role) {
          // this route requires auth, check if logged in
          // if not, redirect to login page.
          return next({ name: 'login', params: { page_expectations: to.fullPath } });
        }
        //if customer guard required login and role is 'user, shop'
        else if (customerGuard && result.role) {
          //check role is 'shop' then next
          if (shopGuard && result.role === role.SHOP) {
            return next();
          } else if (shopGuard && result.role === role.USER) {
            return next({ path: '/shop/register', params: { page_expectations: to.fullPath } });
          } else {
            return next();
          }
        } else {
          //if user has login and user render to indexOfPath then render top-page
          if (indexOfPath) {
            return next('/');
          } else {
            return next();
          }
        }
      });
    })
    .catch(e => {
      // console.log('navi error', e);
      //if user not exits
      if (!customerGuard) {
        return next();
      } else if (customerGuard) {
        return next({
          name: 'login',
          params: {
            page_expectations: to.fullPath
          }
        });
      }
    });
});

// // Global beforeResolve
// router.beforeResolve((to, from, next) => {
//   // console.log('Global -- beforeResolve - fired.')
//   next();
// });

export default router;
